import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder,Validators } from '@angular/forms';
import { DataService } from 'src/app/data.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import { AppConfig } from 'src/app/config';
import { NavigationExtras } from '@angular/router';


@Component({
  selector: 'app-newprocess',
  templateUrl: './newprocess.component.html',
  styleUrls: ['./newprocess.component.scss']
})
export class NewprocessComponent implements OnInit {

  actionForm: FormGroup;
  isLoading = false;
  isError = false;
  mode = "new";
  name = "";
  id = "";
  errorMessage = "";
  metaactionName = "";
  metaactionId = "";
  metalayoutId = "";
  metaobjectName = "";
  metaobjectId = "";
  parentObjects: any[];
  process:any;

  constructor(    private formBuilder: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private appConfig: AppConfig,
    // private navigationExtras: NavigationExtras
    ) {
    this.actionForm = this.formBuilder.group({
      existing: ["master"],
      name: ["", Validators.required],
      metaobject:"",
      metaobjectname: ["", Validators.required],
      metaobjectid: [""],
      description: [""],
      active: true,

    });
   }

  ngOnInit() {

    this.getActiveObjectsByType().then((res) => {
      console.log("response11111", res);
      console.log("parentobjects", this.parentObjects);
    });

    this.route.queryParams.subscribe((params) => {
      this.mode = this.route.snapshot.params.mode;
      this.name = this.route.snapshot.params.name;
      this.id = this.route.snapshot.params.id;
      this.getProcessById();
      console.log(this.mode)
      console.log(this.id)


    });
  }

  existingProcess = [
    { value: "master", label: "Master" },

  ];

  showWarning(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-bottom-right",
      messageClass: "orange darken-4",
      toastClass: "warning-color-dark",
    };
    this.toastrService.warning(data, "", options);
  }

  showSuccess(data: any) {
    let options = {
      enableHtml: true,
      positionClass: "md-toast-top-right",
      timeOut: 3000,
    };
    this.toastrService.success(data, "", options);
  }

  showError(data: any) {
    let options = { enableHtml: true, positionClass: "md-toast-bottom-right" };
    this.toastrService.error(data, "Application Error!", options);
  }

  // parentObjectChange(event: any) {
  //   console.log(event);
  //   console.log(event.target.options[event.target.selectedIndex].text)
  //   console.log(event.target.value);
  //   const selectedid = event.target.value;
  //   const selectedname = event.target.options[event.target.selectedIndex].text;
  //   // const selectedname = event.target.text;

  //   this.actionForm.controls["metaobjectid"].setValue(selectedid);
  //   this.actionForm.controls["metaobjectname"].setValue(selectedname);
  // }

  parentObjectChange(event: { value: string; label: any }) {
    console.log("parentObjectChange", event);
    if (event.value.trim() != "") {
      this.actionForm.controls["metaobjectid"].setValue(event.value);
      this.actionForm.controls["metaobjectname"].setValue(event.label);
    } else {
      this.actionForm.controls["metaobjectid"].setValue("");
      this.actionForm.controls["metaobjectname"].setValue("");
    }
  }

  // parentObjectChange(event: any) {
  //   console.log('Selected ID:', event.target.value);
  //   console.log('Selected Name:', event.target.options[event.target.selectedIndex].text);
  
  //   const selectedid = event.target.value;
  //   const selectedname = event.target.options[event.target.selectedIndex].text;
  
  //   this.actionForm.controls["metaobjectid"].setValue(selectedid);
  //   this.actionForm.controls["metaobjectname"].setValue(selectedname);
  // }
  

  getActiveObjectsByType() {
    return new Promise((resolve, reject) => {
      console.log("getActiveObjectsByType");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          metaobject: {
            objecttype: "Domain",
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getActiveObjectsByType(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            var activeObjects = res.data.metaobjects;
            var objArr = [];
            //just add an empty entry sice this field is optional
            objArr.push({ value: "", label: "--None--" });
            for (let i = 0; i < activeObjects.length; i++) {
              objArr.push({
                value: activeObjects[i].id,
                label: activeObjects[i].name,
              });
            }
            this.parentObjects = objArr;

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No metaobject data!");
            this.errorMessage =
              res != null ? res.message : "No metaobject data!";
            this.isError = true;
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }

  getProcessById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
      subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
      data: {
        process: {
          id: this.id,
          name: this.name
        },
      },
    };
    console.log(this.id);
    this.isLoading = true;
    this.dataService.getProcessById(postOption).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.process = res.data.process[0];
          console.log("Doneeee****", this.process);
          if (this.process != null) {
            this.id = this.process.id;
            this.name = this.process.name;
            this.actionForm.controls["name"].setValue(
              this.process.name
            );
            this.actionForm.controls["metaobjectname"].setValue(
              this.process.metaobjectname
            );

            this.actionForm.controls["metaobjectid"].setValue(
              this.process.metaobjectid
            );

            this.actionForm.controls["metaobject"].setValue(
              this.process.metaobjectid
            );

            this.actionForm.controls["description"].setValue(
              this.process.description
            );

            this.actionForm.controls["active"].setValue(
              this.process.active
            );
          }

          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
          //this.resetDetailFormControls();
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
        //this.resetDetailFormControls();
      }
    );
  }
  

  next(){

    if (this.actionForm.controls["name"].value.toString().trim() == "") {
      this.showWarning("Name is mandatory");
      return;
    }

    if (this.actionForm.controls["metaobjectname"].value.toString().trim() == "") {
      this.showWarning("metaobjectName is mandatory");
      return;
    }

  const formData = this.actionForm.value;
  const metaobjectName = formData.metaobjectname;
  const metaobjectId = formData.metaobjectid;
  const Name = formData.name;
  const Description = formData.description;
  const Active = formData.active;


  if(formData.metaobjectname && formData.Name !=""){
    this.showSuccess("Success");
  console.log(formData)
    this.router.navigateByUrl('home/processes/processfield/'+this.mode +'/'+this.id +'/' +metaobjectName +'/' + metaobjectId + '/'+ Name + '/' + Description + '/' + Active);
  } 
    else {
      console.log("error while routing");
      this.showError("Error while routing");
    
  }

  }

  cancel(){
    this.router.navigateByUrl('home/processes');

  }

}
